import { GRID_UNIT, MONO_FONT_FAMILY, SANS_FONT_FAMILY, SERIF_FONT_FAMILY } from "./default";
export var WEB_THEME = {
  color: {
    light: '#FFFFFF',
    dark: '#000000',
    text: '#555759',
    textMid: '#969696',
    textTitle: '#0D0D0D',
    textSubtle: '#ABABAB',
    bold: '#000000',
    primary: '#FFCA04',
    secondary: '#333333',
    primaryVeryLight: '#FEE7B9',
    error: '#C52A39',
    subtleGrey: '#F5F5F5',
    line: '#BFC0BF',
    lineMid: '#D2D2D2',
    lineSemiSubtle: '#DADADA',
    lineSubtle: '#EEEEEE',
    // inverted color set
    invertedText: '#FFFFFF',
    invertedTextMid: '#BBBBBB',
    // invertedLink: '#FFFFFF',
    // invertedLinkHover: '#FFFFFF',
    invertedLine: '#FFFFFF'
  },
  grid: {
    unit: GRID_UNIT
  },
  font: {
    family: {
      serif: SERIF_FONT_FAMILY,
      sans: SANS_FONT_FAMILY,
      mono: MONO_FONT_FAMILY,
      heading: SANS_FONT_FAMILY,
      copy: SANS_FONT_FAMILY
    }
  }
};